import { Typography } from 'antd'
import {
  CustomMenuItemType,
  NO_NAVIGATE_KEY,
} from '../../e-office-layout/components/dynamic-menu/custom-menu-items-type'
import { PHAN_BO_TRANG_THIET_BI_PREFIX_URL } from './config.phan-bo-trang-thiet-bi'
import { WORKING_EQUIPMENT_PREFIX_URL } from '../modules/working-equipment/constants/config.working-equipment'
import {
  WORKING_EQUIPMENT_ALLOCATION_APPROVED_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_MY_APPROVE_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL,
  WORKING_EQUIPMENT_ALLOCATION_WAITING_APPROVE_PREFIX_URL,
} from '../modules/working-equipment-allocation/constants/config.working-equipment-allocation'
import IconGlobalApp from '../../../utils/IconGlobalApp'
import { ADMIN_CAP_PHAT_TRANG_THIET_BI_PREFIX_URL } from '../modules/admin-cap-phat-trang-thiet-bi/constants/config.admin-cap-phat-trang-thiet-bi'

const CONFIG_PREFIX_URL = 'config'

const LIST_MENU_REPORT: CustomMenuItemType<'submenu'>['children'] = [
  {
    key:
      NO_NAVIGATE_KEY +
      PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
      WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL,
    label: 'Báo cáo',
    children: [
      {
        key: `${PHAN_BO_TRANG_THIET_BI_PREFIX_URL}${WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL}/by-working-equipment`,
        label: 'Theo trang thiết bị',
      },
      {
        key: `${PHAN_BO_TRANG_THIET_BI_PREFIX_URL}${WORKING_EQUIPMENT_ALLOCATION_REPORT_PREFIX_URL}/by-phong-ban`,
        label: 'Theo phòng ban',
      },
    ],
  },
]

const LIST_MENU_PHIEU_CAP_PHAT: CustomMenuItemType<'submenu'>['children'] = [
  {
    key:
      NO_NAVIGATE_KEY +
      PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
      WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL,
    label: 'Phiếu cấp phát',
    children: [
      {
        key:
          PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
          WORKING_EQUIPMENT_ALLOCATION_PREFIX_URL,
        label: 'Tất cả',
      },
      {
        key:
          PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
          WORKING_EQUIPMENT_ALLOCATION_WAITING_APPROVE_PREFIX_URL,
        label: 'Chờ tôi duyệt',
      },
      {
        key:
          PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
          WORKING_EQUIPMENT_ALLOCATION_MY_APPROVE_PREFIX_URL,
        label: 'Được tôi duyệt',
      },
      {
        key:
          PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
          WORKING_EQUIPMENT_ALLOCATION_APPROVED_PREFIX_URL,
        label: 'Đã duyệt',
      },
    ],
  },
]
const LIST_MENU_CAU_HINH: CustomMenuItemType<'submenu'>['children'] = [
  {
    key:
      NO_NAVIGATE_KEY + PHAN_BO_TRANG_THIET_BI_PREFIX_URL + CONFIG_PREFIX_URL,
    label: 'Cấu hình',
    type: 'group',
    children: [
      {
        key:
          PHAN_BO_TRANG_THIET_BI_PREFIX_URL +
          ADMIN_CAP_PHAT_TRANG_THIET_BI_PREFIX_URL,
        label: 'Admin cấp phát',
      },
      {
        key: PHAN_BO_TRANG_THIET_BI_PREFIX_URL + WORKING_EQUIPMENT_PREFIX_URL,
        label: 'Trang thiết bị',
      },
    ],
  },
]

const generateMenu = (
  children: CustomMenuItemType<'submenu'>['children']
): CustomMenuItemType<'submenu'> => ({
  key: `${NO_NAVIGATE_KEY}${PHAN_BO_TRANG_THIET_BI_PREFIX_URL}`,
  label: (
    <Typography.Link strong ellipsis title="Cấp phát trang thiết bị">
      Cấp phát trang thiết bị
    </Typography.Link>
  ),
  icon: <IconGlobalApp name="package-plus" />,
  children,
})

export const LIST_MENU_CAP_PHAT_ADMIN = generateMenu([
  ...LIST_MENU_PHIEU_CAP_PHAT,
  ...LIST_MENU_REPORT,
  ...LIST_MENU_CAU_HINH,
])

export const LIST_MENU_CAP_PHAT_EMPLOYEE = generateMenu(
  LIST_MENU_PHIEU_CAP_PHAT
)
